import $ from 'jquery';
import ko from 'knockout';
import initializeGrid from '../grid/initializeGrid';

ko.bindingHandlers['grid-scroll-container'] = {
	init: function (element: HTMLElement) {
		initializeGrid($(element).closest('.grid'));
	}
}
